import React from "react";
import { Newspaper, Landmark, Globe2, Scale, Link2 } from "lucide-react";

export const SOURCE_TYPES = {
  media: { label: "News Media & Publishers", short: "News Media", Icon: Newspaper, color: "#17685f", background: "#eaf4f1" },
  government: { label: "National Governments", short: "Government", Icon: Landmark, color: "#ad3039", background: "#fbedee" },
  institution: { label: "International Institutions", short: "Institutions", Icon: Globe2, color: "#285ba0", background: "#ebf1fa" },
  authority: { label: "Public Authorities & Regulators", short: "Authorities", Icon: Scale, color: "#716020", background: "#f5f2e5" },
};

export const sourceGroups = (value) => {
  const candidates = Array.isArray(value?.source_groups) ? value.source_groups
    : value?.sources ? value.sources.map(s => s.source_group) : [value?.source_group];
  return Object.keys(SOURCE_TYPES).filter(group => candidates.includes(group));
};

export const SourceTypeMark = ({ groups = [], testId }) => {
  const types = Object.keys(SOURCE_TYPES).filter(group => groups.includes(group));
  const mixed = types.length > 1;
  const single = SOURCE_TYPES[types[0]];
  const Icon = single?.Icon || Link2;
  return <span data-testid={testId} data-source-type={mixed ? "mixed" : types[0] || "unclassified"}
    className="inline-grid shrink-0 place-content-center rounded-md border"
    style={{ width: 32, height: 32, minWidth: 32, color: mixed ? "var(--ink)" : single?.color || "var(--muted)", background: mixed ? "var(--paper)" : single?.background || "var(--surface-2)", borderColor: "var(--hairline)" }} aria-hidden="true">
    {mixed ? <span className="grid grid-cols-2 gap-0.5">{types.map(group => {
      const Symbol = SOURCE_TYPES[group].Icon;
      return <Symbol key={group} size={12} strokeWidth={2} style={{ color: SOURCE_TYPES[group].color }} data-testid={`${testId}-${group}`} />;
    })}</span> : <Icon size={20} strokeWidth={1.65} />}
  </span>;
};

export const SourceTypeLegend = ({ groups, prefix }) => <div className="flex flex-wrap gap-x-4 gap-y-3" data-testid={`${prefix}-types`}>
  {groups.map(group => <span key={group} className="inline-flex items-center gap-2 text-xs min-w-0" data-testid={`${prefix}-type-${group}`}>
    <SourceTypeMark groups={[group]} testId={`${prefix}-type-icon-${group}`} /><span>{SOURCE_TYPES[group].label}</span>
  </span>)}
</div>;